import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["CategoryTag"] */ "/workspace/src/components/atom/categoryTag.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Wrapper"] */ "/workspace/src/components/moleculer/wrapper.tsx");
